import React, { useEffect, useRef } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

// License key (if applicable)
am4core.addLicense("CH332271218");

// Apply animated theme
am4core.useTheme(am4themes_animated);

const MonthlyPredictionChart = (props: any) => {
  const chartRef = useRef<any>(null);

  // Function to transform data from props into chart data format
  const transformData = (data: { [key: number]: number }) => {
    return Object.entries(data).map(([month, value]) => ({
      date: new Date(2024, parseInt(month) - 1, 1), // Convert month number to Date object
      value: value*100,
    }));
  };

  useEffect(() => {
    // Create chart instance
    let chart = am4core.create("chartDiv", am4charts.XYChart);
    chart.data = transformData(props.data); // Use transformed data from props

    // Create X-axis (Date Axis)
    const dateAxis:any = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.strokeWidth = 1;
    dateAxis.renderer.grid.template.strokeOpacity = 0.3;
    dateAxis.renderer.grid.template.stroke = "#fff";

    // Set the base interval to 1 month to ensure monthly ticks
    dateAxis.baseInterval = {
      timeUnit: "month",
      count: 1,
    };

    // Set grid intervals explicitly to ensure months are shown
    dateAxis.gridIntervals.setAll([{ timeUnit: "month", count: 1 }]);

    // Configure minimum grid distance to prevent label skipping
    dateAxis.renderer.minGridDistance = 50;

    // Ensure labels display each month
    dateAxis.dateFormats.setKey("month", "MMM"); // Formats the labels as Jan, Feb, etc.
    dateAxis.periodChangeDateFormats.setKey("month", "MMM");

    // Add a title and customize the appearance of labels
    dateAxis.title.text = "Month";
    dateAxis.title.fill = "#fff";
    dateAxis.title.fontSize = 13;
    dateAxis.renderer.labels.template.fontSize = 10;
    dateAxis.title.fontWeight = "bold";
    dateAxis.renderer.labels.template.fill = "#fff";

    // Optional: Adjust label rotation if needed to fit all labels
    dateAxis.renderer.labels.template.rotation = 0;

    // Create Y-axis (Value Axis)
    let valueAxis:any = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = "Prediction Value(%)";
    valueAxis.title.fill = "#fff";
    valueAxis.title.fontSize = 13;
    valueAxis.title.fontWeight = "bold";
    valueAxis.renderer.grid.template.strokeWidth = 1;
    valueAxis.renderer.grid.template.strokeOpacity = 0.3;
    valueAxis.renderer.grid.template.stroke = "#fff";
    valueAxis.renderer.labels.template.fontSize = 10;
    valueAxis.renderer.labels.template.fill = "#fff";

    // Create Series (Bar/Column Series)
    let series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = "value";
    series.dataFields.dateX = "date";
    series.columns.template.strokeWidth = 0;
    series.columns.template.fill = am4core.color("#f7b047"); // Customize bar color
    series.columns.template.tooltipText = "{dateX.formatDate('MMM')}: {valueY}%";

    // Add Click Event to Columns
    // series.columns.template.events.on("hit", function (ev) {
    //   const dataItem:any = ev.target.dataItem;
    //   const date = dataItem.dataContext.date; // Access the actual date object
    //   const value = dataItem.dataContext.value; // Access the value directly

    //   // Set the tooltip text and show it
    //   series.tooltip.label.text = `${date.toLocaleDateString("en-US", {
    //     month: "short",
    //   })}: ${value}`;
    //   series.tooltip.showAt(ev.target);
    // });

    // Cleanup chart instance
    chartRef.current = chart;
    return () => {
      chart.dispose();
    };
  }, [props.data]); // Add props.data as dependency to update when data changes

  return <div id="chartDiv" style={{ width: "100%", height: "20rem" }}></div>;
};

export default MonthlyPredictionChart;